<script setup lang="ts">
import type { NavItemContentProps } from '@/types/nav';

const props = defineProps<NavItemContentProps>();
</script>

<template>
    <a :class="[props.containerClass, 'nav-item-holder']">
        <v-icon v-if="props.prefixIcon" :icon="props.prefixIcon" :class="props.prefixIconClass" />
        <span> {{ props.displayName }} </span>
        <v-icon v-if="props.suffixIcon" :icon="props.suffixIcon" :class="props.suffixIconClass" />
    </a>
</template>

<style scoped>
.nav-item-holder {
    display: flex;
    align-items: center;
    gap: 7px;
}
</style>
